module.exports = __webpack_public_path__ + "static/img/nbcb.c462f1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/nbcb.png
// module id = t/Ve
// module chunks = 93